import { ControlledForm } from "Components";
import { FormDataType } from "DataTypes/Form";

export const DataArr: FormDataType[] = [
  {
    id: "programName",
    label: "Program Name",
    placeholder: "Select Program Name",
    boxType: "single-select-drop",
    boxSize: 6,
    validatetype: "dropdown",
    required: true,
  },
  {
    id: "activity",
    label: "Activity",
    placeholder: "Select Activity",
    boxType: "input-box",
    boxSize: 6,
    validatetype: "name",
    readOnly: true,
    required: true,
  },
  ControlledForm.FormData.StartDateTime(),
  ControlledForm.FormData.EndDateTime(),
  {
    id: "type",
    label: "Type",
    placeholder: "Select Type",
    boxType: "single-select-drop",
    dropArr: [],
    boxSize: 6,
    validatetype: "dropdown",
    required: true,
  },
  ControlledForm.FormData.Duration(),
  {
    id: "interactive",
    label: "Was interactive communication done with the Patient?",
    placeholder: "Select an option",
    boxType: "empty-block",
    boxSize: 6,
    validatetype: "dropdown",
    dropArr: [],
  },
  ControlledForm.FormData.Notes({ required: true }),
];
